<script setup lang="ts">
interface Props {
  progressPercent: number;
  sections?: number;
  height?: number;
}

const props = withDefaults(defineProps<Props>(), {
  sections: 5,
  height: 20,
});

const clampedProgress = computed(() => Math.min(Math.max(props.progressPercent, 0), 100));
const fillWidth = computed(() => `${clampedProgress.value}%`);
const glowWidth = computed(() => `calc(${fillWidth.value} - 4px)`);

const dividers = computed(() => {
  const count = Math.max(props.sections - 1, 0);
  return Array.from({ length: count }, (_, i) => `${((i + 1) / props.sections) * 100}%`);
});
</script>

<template>
  <span
    :style="{ height: `${props.height}px` }"
    class="border-background relative block w-full overflow-hidden rounded-3xl border bg-white shadow-[inset_0_5px_18px_0_rgba(0,0,0,0.11),_0_0_0_1px_rgba(255,255,255,0.45)]"
  >
    <!-- Coloured fill -->
    <span
      :style="{
        width: fillWidth,
        height: `${props.height - 2}px`,
      }"
      class="absolute top-px left-px bg-secondary transition-all duration-500 ease-out"
    />
    <!-- Glossy highlight -->
    <span
      :style="{
        width: glowWidth,
        height: `${Math.ceil(props.height / 4)}px`,
      }"
      class="absolute top-1 left-[3px] rounded-full bg-white/50 transition-all duration-500 ease-out"
    />
    <!-- Dividers -->
    <template v-for="(left, idx) in dividers" :key="idx">
      <KUICoreIllustration
        :style="{ left }"
        illustration="progress-divider"
        class="absolute top-[2px] h-[calc(100%-4px)] w-[2px]"
      />
    </template>
  </span>
</template>
